import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

export interface SearchCounts {
    isLoad: boolean;
    value: number;

    matchingResultMap?: { [key: number]: { match_percentage: number } };
    usedResumeId?: number;
    isSuitableSearch?: boolean;
}

const searchCounts = autoGeneratedReducer<SearchCounts>({ isLoad: false, value: 0 });

export { searchCounts };
